// ** UI
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';

// ** Components
import Section from '@/components/common/Section';
import PodcastPlayer from './PodcastPlayer';

// ** Types
import type { StrapiComponentProps } from '@/types/strapi';
import type { ComponentBlocksPodcastBlock as BlocksPodcastBlockProps } from '@/types/graphql';

type ComponentBlocksPodcastBlockProps = StrapiComponentProps<BlocksPodcastBlockProps>;

const ComponentBlocksPodcastBlock = ({
	podcasts,
	containerSx,
	podcastSectionTitle
}: ComponentBlocksPodcastBlockProps) => {
	return (
		<Section containerSx={containerSx}>
			<Box
				sx={{
					flexGrow: 1,
					p: {
						xs: 4,
						sm: 4,
						md: 4,
						lg: 16,
						xl: 16
					},
					height: '100%',
					alignItems: 'center',
					width: '100%'
				}}
			>
				{podcastSectionTitle && (
					<Typography
						variant="title-lg"
						component="h2"
						sx={{
							mb: 10,
							color: 'common.black',
							fontSize: { xs: '2rem', md: '2.5rem' },
							lineHeight: { xs: '2.5rem', md: '3rem' },
							letterSpacing: { xs: '-0.64px', md: '-1.2px' }
						}}
					>
						{podcastSectionTitle}
					</Typography>
				)}

				<Grid container>
					{podcasts.map((item) => {
						if (!item) return null;
						const { embedUrl } = item;
						return (
							<Grid size={{ xs: 12 }} key={item.documentId}>
								<PodcastPlayer configUrl={embedUrl} />
							</Grid>
						);
					})}
				</Grid>
			</Box>
		</Section>
	);
};

export default ComponentBlocksPodcastBlock;
